export default {
  name: 'Investment'
};